/* eslint-disable @typescript-eslint/ban-types */
import { createContext } from 'use-context-selector'

type NewUserContextType = {}

export const NewUserContext = createContext<NewUserContextType>(
  {} as NewUserContextType
)
